$(function() {
  $('.sortable').railsSortable();
});
